// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';
import _ from 'lodash';
// local
// views
import PressureBar from './PressureBar';
// css
import './PopupCylinders.css';

class PopupCylinders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    handleOpen = () => this.setState({ isOpen: true });

    handleClose = () => this.setState({ isOpen: false });

    renderContent(cylinders, cylinderSize) {
        return _.map(cylinders, function(cylinder) {
            const key = _.uniqueId('popup_cylinder_');
            return <PressureBar key={key} state={cylinder.state} pressure={cylinder.pressure} cylinderSize={cylinderSize} small />;
        });
    }

    render() {
        const { isOpen } = this.state;
        const { cylinders, cylinderSize } = this.props;
        const trigger = <div className="trigger-more-cylinders">+{cylinders.length}</div>;
        return (
            <Popup
                id="popup-cylinders"
                open={isOpen}
                on="hover"
                trigger={trigger}
                content={this.renderContent(cylinders, cylinderSize)}
                onClose={this.handleClose}
                onOpen={this.handleOpen}
                position="right center"
            />
        );
    }
}

PopupCylinders.propTypes = {
    cylinders: PropTypes.array,
    cylinderSize: PropTypes.number,
};

export default PopupCylinders;
